/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function PackageCreationTemplatesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $routeParams: JS5Object,
    $route: JS5Object,
    $location: JS5Object,
    PackageCreationTemplatesService: JS5Object,
    PermissionsService: JS5Object,
    ModalService: JS5Object,
    NotificationService: JS5Object,
    BreadcrumbService: JS5Object,
    loginService: JS5Object,
    SidebarService: JS5Object,
    $timeout: JS5Function
) {
    this.editData = {};
    this.templateJson = '{}';
    const getData = () => {
        this.loadingIndicator.show = true;
        PackageCreationTemplatesService.getPackageCreationTemplate($routeParams.id).then((packageCreationTemplate: JS5Object) => {
            PackageCreationTemplatesService.originalEditData = _.cloneDeep(packageCreationTemplate);
            this.editData = packageCreationTemplate;
            this.templateJson = JSON.stringify(this.editData.template, null, 2);
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        try {
            const parsedTemplateFromString = JSON.parse(this.templateJson);
            _.set(this.editData, 'template', parsedTemplateFromString);
            if ($routeParams.id === '-1') {
                saveNewPackageCreationTemplate();
            } else {
                updatePackageCreationTemplate();
            }
        } catch (error) {
            NotificationService.createFailureNotification(error.message, '', true, -1);
            this.errorIndex = parseInt(_.chain(error.message)
                .words()
                .last()
                .value());
            this.loadingIndicator.show = false;
        }
    };

    const updatePackageCreationTemplate = () => {
        PackageCreationTemplatesService.updatePackageCreationTemplate(this.editData).then((packageCreationTemplate: JS5Object) => {
            PackageCreationTemplatesService.originalEditData = _.cloneDeep(packageCreationTemplate);
            this.editData = packageCreationTemplate;
            this.editorForm.$setPristine();
            getData();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewPackageCreationTemplate = () => {
        PackageCreationTemplatesService.createPackageCreationTemplate(this.editData).then((packageCreationTemplate: JS5Object) => {
            $route.updateParams({id: packageCreationTemplate.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(PackageCreationTemplatesService.originalEditData);
                this.editorForm.$setPristine();
                this.templateJson = JSON.stringify(this.editData.template, null, 2);
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/templates/search`).search({
                tab: 'PackageCreationTemplates',
            })
        }
    ];


    this.$onInit = () => {
        SidebarService.editService = PackageCreationTemplatesService;
        this.errorIndex = null;
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        PermissionsService.isSystemOperator().then((isSystemOps: boolean) => {
            if (isSystemOps) {
                if ($routeParams.id !== '-1') {
                    if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                        BreadcrumbService.addBreadcrumb({
                            name: 'Edit Package Accept Template',
                            location: '/system/templates/search',
                            params: {tab: 'PackageCreationTemplates', subTab: null}
                        });
                    }
                    getData();
                } else {
                    PackageCreationTemplatesService.originalEditData = _.cloneDeep(this.editData);
                    BreadcrumbService.addBreadcrumb({
                        name: 'Create Package Accept Template',
                        location: '/system/templates/search',
                        params: {tab: 'PackageCreationTemplates', subTab: null}
                    });
                }
            } else {
                $location.url('/login');
            }
        });
    };

    this.$onDestroy = () => {
        PackageCreationTemplatesService.originalEditData = null;
        PackageCreationTemplatesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            PackageCreationTemplatesService.editorForm = this.editorForm;
            BreadcrumbService.editService = PackageCreationTemplatesService;
        });
    };
}


angular.module('prism-ui.packageCreationTemplate').component('packageCreationTemplatesEditView', {
    templateUrl: 'system/templates/packageCreationTemplates/editView/package-creation-templates-edit-view-template.html',
    controller: PackageCreationTemplatesEditViewController,
    bindings: {}
});
